import React, { useEffect, useRef, useState } from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import { useGetProductMenuListMutation } from "../../../../store/user/menuApiSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/storeHooks";
import { menuListInfo, setMenuList } from "../../../../store/stroeApi/menuInfoSlice";
import { setuserInfo } from "../../../../store/user/loginUserSlice";
import { useCookies } from "react-cookie";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay } from 'swiper/modules';


const Header_Pc = () => {
    const location = useLocation()
    const path = location.pathname.split('/')
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const userInfo : any = useAppSelector(state => state.loginUser.userInfo)
    const menuInfo : menuListInfo = useAppSelector(state => state.menuInfo.menuInfo)
    const [cookies, setCookie, removeCookie] = useCookies(['userKey']); // 쿠키에 접근

    const handleTransPage = (page:string) => {
        if(location.pathname !== page){navigate(page)}
    }
    const [getProductMenuListApi] = useGetProductMenuListMutation()
    const getMenuList = async() => {
        const result : any = await getProductMenuListApi({menuType : 'CH'})
        if(result.data.Result === 'true'){
            dispatch(setMenuList({channel : result.data.channel, resolution : result.data.resolution, features : result.data.features}))
        }
    }
    const handleLogout = () => {
        dispatch(setuserInfo({userId : '', account : '', name : '', apiId : '', productId : ''}))
        // navigate('/support/warrentyService/myDashcam')
        // sessionStorage.removeItem('userKey')
        removeCookie('userKey');
        window.location.href = '/support/warrentyService/myDashcam';
    }
    useEffect(()=>{getMenuList()},[])

    const [depthMenu, setDepthMenu] = useState('');
    return(
        <>
        <div className="header_pc">
            <h1>
                <Swiper
                  direction={'vertical'}
                  className="mySwiper"
                  loop={true}
                  modules={[Autoplay]}
                  autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                  }}
                >
                    <SwiperSlide>
                        <Link to="/"><img src="/assets/images/fineVu_logo.png" alt="Fine Vu"/></Link>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Link to="/"><img src="/assets/images/new/finecaddie_logo.png" alt="Fine CADDIE"/></Link>
                    </SwiperSlide>
                </Swiper>
            </h1>

            <div>
                <nav>
                    <ul>
                        <li className={path[1] === 'products' ? 'active' : ''}>
                            <span onClick={() => navigate('/products?ch=&rs=&ft=')}>Products</span>
                            <div className="subMenu">
                                <div>
                                    <div className="leftArea"></div>
                                    <ul>
                                        <li>
                                            <ul>
                                                <li className="none" onMouseOver={() => setDepthMenu('menu1')} onClick={() => navigate('/products?ch=&rs=&ft=')}>
                                                    <span>Dash Cams</span>
                                                </li>
                                                <li className="none" onMouseOver={() => setDepthMenu('menu2')} style={{marginTop: '35px'}} onClick={() => navigate('/products/100?product=UPL2000')}>
                                                    <span>Golf Rangefinder</span>
                                                </li>
                                            </ul>
                                        </li>
                                        {(depthMenu === 'menu1' || '') && (
                                          <>
                                              <li>
                                                  <ul>
                                                      <li>
                                                          <span>By Channel</span>
                                                      </li>
                                                      {menuInfo?.channel?.map((channel: any, index: number) => (
                                                        <>
                                                            {index !== 2 && (
                                                              <li key={index} onClick={() => navigate(`/products?ch=${channel?.menuId}&rs=&ft=`)}>
                                                                  <span>{channel?.menuName}</span>
                                                              </li>
                                                            )}
                                                        </>
                                                      ))}
                                                  </ul>
                                              </li>
                                              <li>
                                                  <ul>
                                                      <li>
                                                          <span>By Resolution</span>
                                                      </li>
                                                      {menuInfo?.resolution?.map((resolution: any, index: number) => (
                                                        <li key={index} onClick={() => navigate(`/products?ch=&rs=${resolution?.menuId}&ft=`)}>
                                                            <span>{resolution?.menuName}</span>
                                                        </li>
                                                      ))}
                                                      <li>
                                                          <span className="disabled">(front cam only)</span>
                                                      </li>
                                                  </ul>
                                              </li>
                                              <li>
                                                  <ul>
                                                      <li>
                                                          <span>By Features</span>
                                                      </li>
                                                      {menuInfo?.features?.map((features: any, index: number) => (
                                                        <li key={index} onClick={() => navigate(`/products?ch=&rs=&ft=${features?.menuId}`)}>
                                                            <span>{features?.menuName}</span>
                                                        </li>
                                                      ))}
                                                  </ul>
                                              </li>
                                              <li>
                                                  <ul>
                                                      <li>
                                                          <span>Accessories</span>
                                                      </li>
                                                      <li className="" onClick={() => handleTransPage('/products/39?product=FinePower-250')}>
                                                          <span>BATTERY PACK</span>
                                                      </li>
                                                      <li className="" onClick={() => handleTransPage('/products/39?product=FinePower-250')}>
                                                          <span>Hardwire Kit</span>
                                                      </li>
                                                  </ul>
                                              </li>
                                          </>
                                        )}
                                        {depthMenu === 'menu2' && (
                                          <li>
                                              <ul>
                                                  <li className="none">
                                                      <span></span>
                                                  </li>
                                                  <li className="" onClick={() => handleTransPage('/products/100?product=UPL2000')}>
                                                      <span>UPL2000</span>
                                                  </li>
                                                  <li className="" onClick={() => handleTransPage('/products/101?product=UPL9')}>
                                                      <span>UPL9</span>
                                                  </li>
                                              </ul>
                                          </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </li>
                        <li onClick={() => handleTransPage('/productComparison')}>
                            <span>Product Comparison</span>
                        </li>
                        <li>
                            <span>Creator Support</span>
                            <div className="subMenu">
                                <div>
                                    <div className="leftArea"></div>
                                    <ul>
                                        <li>

                                        </li>
                                        <li>

                                        </li>
                                        <li style={{marginLeft: '-30px'}}>
                                            <ul>
                                                <li>
                                                    <span>Brand Assets</span>
                                                </li>
                                                <li onClick={() => handleTransPage('/creator-support/brand-assets?tab=1')}>
                                                    <span>Product Images</span>
                                                </li>
                                                <li onClick={() => handleTransPage('/creator-support/brand-assets?tab=2')}>
                                                    <span>Video Footage</span>
                                                </li>
                                                <li onClick={() => handleTransPage('/creator-support/brand-assets?tab=3')}>
                                                    <span>Brand Identity</span>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                        <li>
                            <span>Contact</span>
                            <div className="subMenu">
                                <div>
                                    <div className="leftArea"></div>
                                    <ul>
                                        <li>
                                            <ul>
                                                <li>
                                                    <span>Customer Support</span>
                                                </li>
                                                <li onClick={() => handleTransPage('/support/warrentyService/prRegistration')}>
                                                    <span>Product Registration</span>
                                                </li>
                                                <li onClick={() => handleTransPage('/support/warrentyService/policy')}>
                                                    <span>Warranty Policy</span>
                                                </li>
                                                <li onClick={() => handleTransPage(userInfo?.userId === 'null' || userInfo?.userId === null || userInfo?.userId === '' ? `/support/warrentyService/myDashcam` : `/support/warrentyService/myDashcam/${userInfo?.userId}`)}>
                                                    <span>My Page</span>
                                                </li>
                                                <li onClick={() => handleTransPage('/support/warrentyService/trouble-shooting')}>
                                                    <span>Troubleshooting</span>
                                                </li>
                                                <li onClick={() => handleTransPage('/location')}>
                                                    <span>Where to Buy</span>
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <ul>
                                                <li>
                                                    <span>&nbsp;</span>
                                                </li>
                                                <li onClick={() => handleTransPage('/support/download/dashcam')}>
                                                    <span>FineVu Dashcam</span>
                                                </li>
                                                <li onClick={() => handleTransPage('/support/download/wifiapp')}>
                                                    <span>FineVu App</span>
                                                </li>
                                                <li onClick={() => handleTransPage('/support/download/pcplayer')}>
                                                    <span>FineVu PC Player</span>
                                                </li>
                                                <li className="none" onClick={() => handleTransPage('/support/warrentyService/contact')}>
                                                    <span>Customer Contact</span>
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <ul>
                                                <li>
                                                    <span>Dealer Support</span>
                                                </li>
                                                <li className="none" onClick={() => handleTransPage('/contact/dealer-support/dealer-contact')}>
                                                    <span>Dealer Contact</span>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                        {/*<li>
                            <span>Support</span>
                        </li>*/}
                        <li onClick={() => handleTransPage('/blog')}>
                            <span>Blog</span>
                        </li>
                        <li onClick={() => handleTransPage('/fineVu')}>
                            <span>About us</span>
                        </li>
                        <li>
                            <span>US Toll-Free (+1) 646 895 6154</span>
                        </li>
                    </ul>
                </nav>
                <div className="rightBox">
                    {userInfo?.userId === 'null' || userInfo?.userId === null || userInfo?.userId === '' ?
                      <>
                          <button className="myDashCamBtn" onClick={() => handleTransPage('/support/warrentyService/myDashcam')}>My Page</button>
                          <button className="logoutBtn active" onClick={() => handleTransPage('/support/warrentyService/myDashcam')}>Login</button>
                      </>
                      :
                      <>
                          <button className="myDashCamBtn" onClick={() => handleTransPage(`/support/warrentyService/myDashcam/${userInfo?.userId}?productId=${userInfo.productId}`)}>My Page</button>
                          <button className="logoutBtn active" onClick={handleLogout}>Logout</button>
                      </>
                    }
                    {/* <!-- 로그인 했을 때만 활성화 --> */}
                </div>
            </div>
        </div>
        </>
    )
}
export default Header_Pc;
